import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';

interface DeletePropertyDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  propertyAddress: string;
  onConfirm: () => void;
}

export function DeletePropertyDialog({
  open,
  onOpenChange,
  propertyAddress,
  onConfirm,
}: DeletePropertyDialogProps) {
  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-red-600 dark:text-red-500">
            Usunąć nieruchomość?
          </DialogTitle>
          <DialogDescription className="text-[14px] leading-relaxed pt-2">
            Czy na pewno chcesz usunąć nieruchomość <strong>"{propertyAddress}"</strong>?
            Wszystkie przypisane zdjęcia (oryginały i rendery) zostaną bezpowrotnie usunięte.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="flex-1 sm:flex-initial"
          >
            Anuluj
          </Button>
          <Button
            variant="default"
            onClick={handleConfirm}
            className="flex-1 sm:flex-initial bg-red-600 hover:bg-red-700 text-white border-none shadow-sm"
          >
            Usuń
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
